import { getErrorsByTransString, getTranslationString, translationErrorLog } from "../cont/Translation"

const getTranslationStringById = (id, translationStrings, currentLang, defaultString = false, debug = false) => {
    if(!translationStrings || !translationStrings.hasOwnProperty(id)) {
        if(defaultString){
            translationErrorLog(debug, 'No translation for "' + id + '". Use defaultString "' + defaultString + '"')
            return defaultString
        } else {
            translationErrorLog(debug, 'No translation for "' + id + '" and no defaultString')
            return ''
        }
    } else {
        let transString = getTranslationString(translationStrings[id], currentLang)

        return getErrorsByTransString(id, transString, defaultString, currentLang, debug)
    }
}

export default getTranslationStringById